import { render, staticRenderFns } from "./EvolutionSystem.vue?vue&type=template&id=5042ffd6&scoped=true"
import script from "./EvolutionSystem.vue?vue&type=script&lang=js"
export * from "./EvolutionSystem.vue?vue&type=script&lang=js"
import style0 from "./EvolutionSystem.vue?vue&type=style&index=0&id=5042ffd6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5042ffd6",
  null
  
)

export default component.exports